module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('el-row', {
    staticClass: "headTop"
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n        分店：\n        "), _c('el-select', {
    staticClass: "w150",
    attrs: {
      "placeholder": "请选择分店"
    },
    on: {
      "change": function($event) {
        return _vm.changeShopData(_vm.shopNum)
      }
    },
    model: {
      value: (_vm.shopNum),
      callback: function($$v) {
        _vm.shopNum = $$v
      },
      expression: "shopNum"
    }
  }, _vm._l((this.shopList), function(item) {
    return _c('el-option', {
      key: item.shopNum,
      attrs: {
        "label": item.name,
        "value": item.shopNum
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBtn),
      expression: "showBtn"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-refresh",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.synData()
      }
    }
  }, [_vm._v("同步数据")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "推荐类型",
      "visible": _vm.dialogVisible,
      "width": "1000px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formparams",
    attrs: {
      "model": _vm.formparams,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "推荐数量",
      "prop": "number"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "请输入推荐数量",
      "maxlength": "2"
    },
    model: {
      value: (_vm.formparams.number),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "number", _vm._n($$v))
      },
      expression: "formparams.number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "显示状态",
      "prop": "status"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formparams.status),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "status", $$v)
      },
      expression: "formparams.status"
    }
  }, _vm._l((this.statusType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.lable,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "推荐方式",
      "prop": "recommendType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formparams.recommendType),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "recommendType", $$v)
      },
      expression: "formparams.recommendType"
    }
  }, _vm._l((this.recommendTypeS), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.lable,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('formparams')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('formparams')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tableList"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tableData,
      "height": "73vh",
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "recommendname",
      "label": "推荐模块"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "推荐数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(" " + _vm._s(scope.row.number) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "显示状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('div', [_vm._v(" 否 ")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('div', [_vm._v(" 是 ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "推荐方式"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.recommendtype == 0) ? _c('div', [_vm._v(" 自动 ")]) : _vm._e(), _vm._v(" "), (scope.row.recommendtype == 1) ? _c('div', [_vm._v(" 手动 ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "300",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.setInfo(scope.row)
            }
          }
        }, [_vm._v("配置详情")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "pageination",
    staticStyle: {
      "display": "none"
    }
  }, [_c('el-col', [_c('el-pagination', {
    staticStyle: {
      "textAlign": "center",
      "marginTop": "10px"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 40, 80, 100],
      "page-size": 20,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": this.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6f8849af"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/hotRecom/hotRecom.vue
// module id = 615
// module chunks = 70